<script setup>
import { useI18n } from 'vue-i18n';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

import Logo from 'next/icon/Logo.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ComposeConversation from 'dashboard/components-next/NewConversation/ComposeConversation.vue';
import TopBarProfileMenu from './TopBarProfileMenu.vue';

defineEmits(['openKeyShortcutModal', 'showCreateAccountModal']);

const { t } = useI18n();

const onComposeOpen = toggleFn => {
  toggleFn();
  emitter.emit(BUS_EVENTS.NEW_CONVERSATION_MODAL, true);
};

const onComposeClose = () => {
  emitter.emit(BUS_EVENTS.NEW_CONVERSATION_MODAL, false);
};
</script>

<template>
  <header
    class="flex items-center gap-3 h-[120px] px-4 border-b border-n-weak bg-n-solid-2 flex-shrink-0 z-30"
  >
    <!-- Esquerda: Logo -->
    <div class="flex items-center gap-2 flex-shrink-0 w-[200px]">
      <Logo class="h-8 w-auto" />
    </div>

    <!-- Centro: vazio -->
    <div class="flex-1 min-w-0" />

    <!-- Direita: Search + Compose + Profile Menu -->
    <div class="flex items-center gap-2 flex-shrink-0">
      <RouterLink
        :to="{ name: 'search' }"
        :aria-label="t('COMBOBOX.SEARCH_PLACEHOLDER')"
      >
        <Button
          icon="i-lucide-search"
          color="slate"
          size="sm"
          class="!h-9 !w-9 !bg-n-solid-3 dark:!bg-n-black/30 !outline-n-weak !text-n-slate-11 !rounded-lg"
        />
      </RouterLink>
      <ComposeConversation align-position="left" @close="onComposeClose">
        <template #trigger="{ toggle }">
          <Button
            icon="i-lucide-pencil"
            color="slate"
            size="sm"
            class="!h-9 !w-9 !bg-n-solid-3 dark:!bg-n-black/30 !outline-n-weak !text-n-slate-11 !rounded-lg"
            @click="onComposeOpen(toggle)"
          />
        </template>
      </ComposeConversation>
      <TopBarProfileMenu
        @open-key-shortcut-modal="$emit('openKeyShortcutModal')"
        @show-create-account-modal="$emit('showCreateAccountModal')"
      />
    </div>
  </header>
</template>
